import React from 'react';
import {
  Box,
  Flex,
  Text,
  Wrap,
  WrapItem,
  Stack,
  Portal,
  HoverCard,
} from '@chakra-ui/react';
import { useAppTheme } from '../../Hooks/useAppTheme';

export const InfoCard = ({ icon, data, buttons }) => {
  const theme = useAppTheme();
  
  return (
    <Box
      position="relative"
      bg={theme.bgCard}
      rounded="lg"
      shadow="sm"
      p={{ base: 3, md: 4 }}
      w="100%"
      borderWidth={1}
      borderColor={theme.borderPrimary}
    >
      {/* Icon badge */}
      <Box
        position="absolute"
        top="-16px"
        left="16px"
        bg={theme.brandPrimary}
        p={3}
        rounded="md"
        color={theme.iconText}
        shadow="md"
        zIndex={1}
      >
        {icon}
      </Box>

      {/* Responsive Grid */}
      <Wrap spacing="0" justify="space-between" mt={6}>
        {data.map((item, index) => {
          const boxContent = item.inline ? (
            <Text fontWeight="semibold" style={{ color: theme.textPrimary }}>
              {item.title}:{' '}
              <Text as="span" fontWeight="medium" style={{ color: theme.textSecondary }}>
                {item.value.id}
              </Text>
            </Text>
          ) : (
            <Flex direction="column">
              <Text fontSize="sm" fontWeight="medium" style={{ color: theme.textSecondary }} mb={1}>
                {item.title}
              </Text>
              <Text fontSize="lg" fontWeight="bold" style={{ color: theme.textPrimary }}>
                {item.value}
              </Text>
            </Flex>
          );

          const wrapItemStyles = {
            flex: '1 1 220px',
            px: 2,
            py: 3,
            minW: '160px',
            maxW: '100%',
            cursor: 'pointer',
            transition: 'all 0.2s ease-in-out',
            transform: 'scale(1)',
            border: '1px solid',
            borderColor: 'transparent',
            _hover: {
              transform: 'scale(1.03)',
              boxShadow: 'lg',
              bg: theme.bgSecondary,
              borderColor: theme.brandPrimary,
              rounded: 'md',
            },
            position: 'relative',
          };

          const wrapItem = item.hoverDetails && !item.inline ? (
            <HoverCard.Root size="sm" key={index}>
              <HoverCard.Trigger asChild>
                <WrapItem {...wrapItemStyles}>
                  <Box w="100%">{boxContent}</Box>

                  {/* Vertical Divider */}
                  {index !== data.length - 1 && (
                    <Box
                      position="absolute"
                      top="15%"
                      bottom="15%"
                      right="0"
                      width="1px"
                      bgGradient="linear(to-b, transparent, gray.300, transparent)"
                    />
                  )}
                </WrapItem>
              </HoverCard.Trigger>

              <Portal>
                <HoverCard.Positioner>
                  <HoverCard.Content
                    bg={theme.bgCard}
                    rounded="md"
                    shadow="lg"
                    borderWidth={1}
                    borderColor={theme.borderPrimary}
                    py={2}
                    px={3}
                    transition="all 0.2s ease"
                    transform="scale(1)"
                    _hover={{
                      transform: 'scale(1.03)',
                      boxShadow: 'xl',
                      borderColor: theme.brandPrimary,
                    }}
                    // Make Total Balance hover card wider
                    minWidth={item.title === 'Total Balance' ? "250px" : "70%"}
                    width="auto"
                  >
                    <HoverCard.Arrow />
                    <Stack spacing={2}>{item.hoverDetails}</Stack>
                  </HoverCard.Content>
                </HoverCard.Positioner>
              </Portal>
            </HoverCard.Root>
          ) : (
            <WrapItem {...wrapItemStyles} key={index}>
              <Box w="100%">{boxContent}</Box>

              {index !== data.length - 1 && (
                <Box
                  position="absolute"
                  top="15%"
                  bottom="15%"
                  right="0"
                  width="1px"
                  bgGradient="linear(to-b, transparent, gray.300, transparent)"
                />
              )}
            </WrapItem>
          );

          return wrapItem;
        })}
      </Wrap>

      {/* Action Buttons */}
      {buttons && <Box mt={4}>{buttons}</Box>}
    </Box>
  );
};